<template>
  <div class="dashboard">
    <h3>Outer Totalistic Cellular Automata(2D)</h3>
    <OuterTotalisticRuleViewer @ruleChanged="onRuleChanged"></OuterTotalisticRuleViewer>
    <TwoDimCanvas :width="width" :height="height"></TwoDimCanvas>
    <small id="age">{{automaton.age}}</small>
    <el-button-group>
      <el-button @click="init" style="width: 80px;">Init</el-button>
      <el-button @click="run" v-if="!running"
                 icon="el-icon-caret-right"
                 style="width: 100px">Run</el-button>
      <el-button @click="stop" v-if="!!running"
                 icon="el-icon-close"
                 style="width: 100px">Stop</el-button>
    </el-button-group>

    <el-form>
      <el-form-item>
        <el-slider v-model="config.density"
                   :min="0" :max="1" :step="0.01"
                   label="Density"
                   ></el-slider>
      </el-form-item>
      <el-form-item label="Color">
        <el-col :span="5">
          <el-color-picker v-model="config.aliveColor"></el-color-picker>
        </el-col>
        <el-col :span="1">
          <el-color-picker v-model="config.deadColor"></el-color-picker>
        </el-col>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { OuterTotalisticAutomaton } from '@/ca'
import TwoDimCanvas from '@/components/TwoDimCanvas'
import OuterTotalisticRuleViewer from '@/components/OuterTotalisticRuleViewer'
export default {
  components: {
    TwoDimCanvas,
    OuterTotalisticRuleViewer
  },
  data () {
    return {
      width: 600,
      height: 300,
      automaton: new OuterTotalisticAutomaton({width: 200, height: 100}),
      running: false,
      config: {
        aliveColor: '#000',
        deadColor: '#f7f4e3',
        density: 0.5,
        rule: {
          alive: [0, 0, 1, 1, 0, 0, 0, 0, 0],
          dead: [0, 0, 0, 1, 0, 0, 0, 0, 0]
        }
      }
    }
  },
  computed: {
    cellSize () {
      return this.width / this.automaton.width
    },
    rule () {
      return this.config.rule
    }
  },
  provide () {
    return {
      automaton: this.automaton,
      config: this.config
    }
  },
  watch: {
    rule: {
      deep: true,
      handler (val) {
        let ruleFun = OuterTotalisticAutomaton.makeOuterTotalisticRule(val)
        this.automaton.setRule(ruleFun)
      }
    }
  },
  methods: {
    init () {
      this.automaton.initWorld({density: this.config.density})
    },
    run () {
      this.loop()
    },
    step () {
      this.automaton.oneStep()
    },
    loop () {
      this.step()
      this.running = window.requestAnimationFrame(this.loop)
    },
    stop () {
      if (this.running) {
        window.cancelAnimationFrame(this.running)
        this.running = false
      }
    },
    onRuleChanged ({state, index}) {
      let newVal = 1 - this.config.rule[state][index]
      this.$set(this.config.rule[state], index, newVal)
    }
  },
  mounted () {
    this.automaton.initWorld({density: this.config.desnity})
  }
}
</script>

<style scoped lang="scss">
.dashboard {
  width: 600px;
  margin: 0 auto;
  position: relative;
  #age {
    position: absolute;
    left: 5px;
    color: #777;
  }
}

</style>
